var map = {
	"./ion-action-sheet.entry.js": [
		396,
		5
	],
	"./ion-alert.entry.js": [
		397,
		6
	],
	"./ion-app_8.entry.js": [
		398,
		7
	],
	"./ion-avatar_3.entry.js": [
		399,
		17
	],
	"./ion-back-button.entry.js": [
		400,
		18
	],
	"./ion-backdrop.entry.js": [
		401,
		43
	],
	"./ion-button_2.entry.js": [
		402,
		19
	],
	"./ion-card_5.entry.js": [
		403,
		20
	],
	"./ion-checkbox.entry.js": [
		404,
		21
	],
	"./ion-chip.entry.js": [
		405,
		22
	],
	"./ion-col_3.entry.js": [
		406,
		44
	],
	"./ion-datetime_3.entry.js": [
		407,
		10
	],
	"./ion-fab_3.entry.js": [
		408,
		23
	],
	"./ion-img.entry.js": [
		409,
		45
	],
	"./ion-infinite-scroll_2.entry.js": [
		410,
		46
	],
	"./ion-input.entry.js": [
		411,
		24
	],
	"./ion-item-option_3.entry.js": [
		412,
		25
	],
	"./ion-item_8.entry.js": [
		413,
		26
	],
	"./ion-loading.entry.js": [
		414,
		27
	],
	"./ion-menu_3.entry.js": [
		415,
		28
	],
	"./ion-modal.entry.js": [
		416,
		8
	],
	"./ion-nav_2.entry.js": [
		417,
		14
	],
	"./ion-popover.entry.js": [
		418,
		9
	],
	"./ion-progress-bar.entry.js": [
		419,
		29
	],
	"./ion-radio_2.entry.js": [
		420,
		30
	],
	"./ion-range.entry.js": [
		421,
		31
	],
	"./ion-refresher_2.entry.js": [
		422,
		11
	],
	"./ion-reorder_2.entry.js": [
		423,
		16
	],
	"./ion-ripple-effect.entry.js": [
		424,
		47
	],
	"./ion-route_4.entry.js": [
		425,
		32
	],
	"./ion-searchbar.entry.js": [
		426,
		33
	],
	"./ion-segment_2.entry.js": [
		427,
		34
	],
	"./ion-select_3.entry.js": [
		428,
		35
	],
	"./ion-slide_2.entry.js": [
		429,
		48
	],
	"./ion-spinner.entry.js": [
		430,
		13
	],
	"./ion-split-pane.entry.js": [
		431,
		49
	],
	"./ion-tab-bar_2.entry.js": [
		432,
		36
	],
	"./ion-tab_2.entry.js": [
		433,
		15
	],
	"./ion-text.entry.js": [
		434,
		37
	],
	"./ion-textarea.entry.js": [
		435,
		38
	],
	"./ion-toast.entry.js": [
		436,
		39
	],
	"./ion-toggle.entry.js": [
		437,
		12
	],
	"./ion-virtual-scroll.entry.js": [
		438,
		50
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 210;
module.exports = webpackAsyncContext;